// Environment configuration
export const config = {
  API_BASE_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000/api/v1',
  APP_NAME: process.env.REACT_APP_NAME || 'LetsBoostUp',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  NODE_ENV: process.env.NODE_ENV || 'development',
} as const;

export default config;
